import React, { useEffect, useState } from "react";
import { Loader } from "../Loader/Loader";

interface PreloadImageProps {
  imageSrc: string;
  alt?: string;
  className?: string;
}

const PreloadImage: React.FC<PreloadImageProps> = ({
  imageSrc,
  alt = "",
  className = "",
}) => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const img = new Image();
    img.src = imageSrc;
    img.onload = () => {
      setIsLoaded(true);
    };
  }, [imageSrc]);

  return (
    <>
      {isLoaded ? (
        <img src={imageSrc} className={className} alt={alt} loading="lazy" />
      ) : (
        <Loader />
      )}
    </>
  );
};

export default PreloadImage;
